<template>
  <Layout>
    <Loader :loading="loading" no-axios>
      <div v-if="(model || {}).id">
        <div class="row">
          <div class="col-md-12">
            <a @click="$router.back()">
              <div class="container-title d-flex align-items-center">
                          <span class="me-2">
                            <svg fill="none" height="16" viewBox="0 0 16 16" width="16"
                                 xmlns="http://www.w3.org/2000/svg">
                              <path
                                  d="M6.875 15.3001L0.275 8.70008C0.175 8.60008 0.104 8.49175 0.0619998 8.37508C0.0206665 8.25842 0 8.13342 0 8.00008C0 7.86675 0.0206665 7.74175 0.0619998 7.62508C0.104 7.50842 0.175 7.40008 0.275 7.30008L6.875 0.700082C7.05833 0.516749 7.28733 0.420749 7.562 0.412083C7.83733 0.404083 8.075 0.500082 8.275 0.700082C8.475 0.883416 8.57933 1.11242 8.588 1.38708C8.596 1.66242 8.5 1.90008 8.3 2.10008L3.4 7.00008H14.575C14.8583 7.00008 15.096 7.09575 15.288 7.28708C15.4793 7.47908 15.575 7.71675 15.575 8.00008C15.575 8.28342 15.4793 8.52075 15.288 8.71208C15.096 8.90408 14.8583 9.00008 14.575 9.00008H3.4L8.3 13.9001C8.48333 14.0834 8.57933 14.3167 8.588 14.6001C8.596 14.8834 8.5 15.1167 8.3 15.3001C8.11667 15.5001 7.88333 15.6001 7.6 15.6001C7.31667 15.6001 7.075 15.5001 6.875 15.3001Z"
                                  fill="#6C7589"/>
                            </svg>
                          </span>
                {{ $t("odoo_sale_invoices.singular") }}
              </div>
            </a>
            <b-card v-bind="cardAttrs">
              <b-card-body>
                <div class="row">
                  <div class="col-md-6">
                    <div class="">
                      <div class="row g-0 description-detail">
                        <div class="col-md-4 label font-size-500">
                          {{ lodash.startCase($t(`${this.resourceRoute}.invoice_number`)) }}
                        </div>
                        <div class="col-md-8 value text-sm">
                          {{ model.invoice_number }}
                        </div>
                      </div>
                      <div class="row g-0 description-detail">
                        <div class="col-md-4 label font-size-500">
                          {{ lodash.startCase($t(`${this.resourceRoute}.ticket_id`)) }}
                        </div>
                        <div class="col-md-8 value text-sm d-flex gap-1">
                          <div
                              v-for="(ticket, index) in uniqueTickets"
                              :key="`ticket-${ticket.id}`"
                          >
                            <router-link
                                :to="`/tickets/${ticket.id}`">
                              {{ ticket.id }}
                            </router-link>
                            <span v-if="index < uniqueTickets.length - 1">, </span>
                          </div>
                        </div>
                      </div>
                      <div class="row g-0 description-detail">
                        <div class="col-md-4 label font-size-500">
                          {{ lodash.startCase($t(`${this.resourceRoute}.sale_order_id`)) }}
                        </div>
                        <div class="col-md-8 value text-sm d-flex gap-1">
                          <div
                              v-for="(order, index) in uniqueOrders"
                              :key="`purchase-order-${order.id}`"
                          >
                            <router-link
                                :to="`/sale_notes/${order.id}`">
                              {{ order.id }}
                            </router-link>
                            <span v-if="index < uniqueOrders.length - 1">, </span>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="col-md-6">
                    <div class="">
                      <div class="row g-0 description-detail">
                        <div class="col-md-4 label font-size-500">
                          {{ lodash.startCase($t(`${this.resourceRoute}.state`)) }}
                        </div>
                        <div class="col-md-8 value text-sm">
                          <status-badge
                              v-if="model.state"
                              entity="odoo_account_move"
                              type="status"
                              :status="model.state"
                          ></status-badge>
                          <span v-else>-</span>
                        </div>
                      </div>
                      <div class="row g-0 description-detail">
                        <div class="col-md-4 label font-size-500">
                          {{ lodash.startCase($t(`${this.resourceRoute}.payment_state`)) }}
                        </div>
                        <div class="col-md-8 value text-sm">
                          <status-badge
                              v-if="model.payment_state"
                              entity="odoo_account_move"
                              type="payment_status"
                              :status="model.payment_state"
                          ></status-badge>
                          <span v-else>-</span>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <hr/>
                <div class="row">
                  <div class="col-md-4 d-flex flex-column gap-3">
                    <div class="description-detail">
                      <div class="label font-size-500">
                        {{ lodash.startCase($t(`${this.resourceRoute}.from`)) }}
                      </div>
                      <div class="text-neutral-600">
                        {{ lodash.startCase(customerLabelFromBankAccount(model.outstanding_account)) }}
                      </div>
                    </div>
                    <div class="description-detail">
                      <div class="label font-size-500">
                        {{ lodash.startCase($t(`${this.resourceRoute}.to`)) }}
                      </div>
                      <div class="text-neutral-600">
                        {{ lodash.startCase(customerLabelFromBankAccount(model.destination_account)) }}
                      </div>
                    </div>
                    <div class="description-detail">
                      <div class="label font-size-500">
                        {{ lodash.startCase($t(`${this.resourceRoute}.amount`)) }}
                      </div>
                      <div class="text-neutral-600">
                        {{ $numeral(model.amount).format("$ 0,0.[00]") }}
                      </div>
                    </div>
                    <div class="description-detail">
                      <div class="label font-size-500">
                        {{ lodash.startCase($t(`${this.resourceRoute}.date`)) }}
                      </div>
                      <div class="text-neutral-600">
                        {{ $moment.utc(model.date).local().format("DD MMMM YYYY") }}
                      </div>
                    </div>
                    <div class="description-detail">
                      <div class="label font-size-500">
                        {{ lodash.startCase($t(`${this.resourceRoute}.description`)) }}
                      </div>
                      <div class="text-neutral-600">
                        <span v-if="model.description" v-html="model.description"></span>
                        <span v-else>-</span>
                      </div>
                    </div>
                  </div>
                  <div class="col-md-4 d-flex flex-column gap-3">
                    <div class="description-detail">
                      <div class="label font-size-500">
                        {{ lodash.startCase($t(`${this.resourceRoute}.outstanding_account`)) }}
                      </div>
                      <div class="text-neutral-600">
                        {{ bankAccountLabel(model.outstanding_account) }}
                      </div>
                    </div>
                    <div class="description-detail">
                      <div class="label font-size-500">
                        {{ lodash.startCase($t(`${this.resourceRoute}.destination_account`)) }}
                      </div>
                      <div class="text-neutral-600">
                        {{ bankAccountLabel(model.destination_account) }}
                      </div>
                    </div>
                  </div>
                </div>
                <hr>
                <div class="row">
                  <div class="col-12">
                    <b-table-simple responsive>
                      <b-thead>
                        <b-tr>
                          <b-th style="background-color: white">{{ lodash.startCase($t(`odoo_account_payment_lines.label`)) }}</b-th>
                          <b-th class="text-right" style="background-color: white">{{ lodash.startCase($t(`odoo_account_payment_lines.quantity`)) }}</b-th>
                          <b-th style="background-color: white">{{ lodash.startCase($t(`odoo_account_payment_lines.UoM`)) }}</b-th>
                          <b-th class="text-right" style="background-color: white">{{ lodash.startCase($t(`odoo_account_payment_lines.price_unit`)) }}</b-th>
                          <b-th class="text-right" style="background-color: white">{{ lodash.startCase($t(`odoo_account_payment_lines.price_subtotal`)) }}</b-th>
                        </b-tr>
                      </b-thead>
                      <b-tbody>
                        <b-tr v-for="line in linesToShow" :key="`product-line-${line.id}`">
                          <template v-if="line.display_type === 'product'">
                            <b-td>{{ line.name }}</b-td>
                            <b-td class="text-right">{{ $numeral(line.quantity).format('0,0.[00]') }}</b-td>
                            <b-td>{{ line.odoo_product_uom_name }}</b-td>
                            <b-td class="text-right">{{ $numeral(line.price_unit).format('$ 0,0.[00]') }}</b-td>
                            <b-td class="text-right">{{ $numeral(line.price_subtotal).format('$ 0,0.[00]') }}</b-td>
                          </template>
                          <template v-else>
                            <b-td colspan="5" class="font-weight-semibold" style="background-color: #f2f2f2">{{ line.name }}</b-td>
                          </template>
                        </b-tr>
                      </b-tbody>
                    </b-table-simple>
                  </div>
                </div>
                <div class="row">
                  <div class="col-12">
                    <b-table-simple borderless small>
                      <b-tbody>
                        <b-tr>
                          <b-th class="text-right">{{ lodash.startCase($t(`${this.resourceRoute}.amount_untaxed`)) }}:</b-th>
                          <b-td class="text-right" style="width: 150px">{{ $numeral(model.amount_untaxed).format('$ 0,0.[00]') }}</b-td>
                        </b-tr>
                        <b-tr>
                          <b-th class="text-right">{{ lodash.startCase($t(`${this.resourceRoute}.amount_tax`)) }}:</b-th>
                          <b-td class="text-right" style="width: 150px">{{ $numeral(model.amount_tax).format('$ 0,0.[00]') }}</b-td>
                        </b-tr>
                        <b-tr>
                          <b-th class="text-right">{{ lodash.startCase($t(`${this.resourceRoute}.amount_total`)) }}:</b-th>
                          <b-td class="text-right" style="width: 150px">{{ $numeral(model.amount_total).format('$ 0,0.[00]') }}</b-td>
                        </b-tr>
                      </b-tbody>
                    </b-table-simple>
                  </div>
                </div>
                <hr>
                <div class="row">
                  <div class="col-12 font-size-500">
                    {{ lodash.startCase($t(`${this.resourceRoute}.attachment`)) }}
                  </div>
                  <div v-if="model.odoo_ir_attachments.length" class="clearfix">
                    <b-img
                        v-for="(file, key) in model.odoo_ir_attachments"
                        :key="`odoo-account-payment-file-${file.id}`"
                        :alt="`Payment Image ${key}`"
                        :src="file.url"
                        class="mx-1"
                        style="height: 150px;width: 150px;object-fit: cover;cursor: pointer;"
                        thumbnail
                        @click="openImageInNewTab(file.url)"
                    />
                  </div>
                  <div v-else class="text-neutral-600">
                    {{ $t(`${this.resourceRoute}.there_is_no_attachment`) }}
                  </div>
                </div>
              </b-card-body>
            </b-card>
          </div>
        </div>
      </div>
    </Loader>
  </Layout>
</template>

<script>
import ModelShow from "../models/show";
import Row from "@/components/models/show/custom-row";
import JalaAppIcon from '@/assets/icons/JalaApp.svg'
import JalaHarvestIcon from '@/assets/icons/JalaHarvest.svg'
import JalaProIcon from '@/assets/icons/JalaPro.svg'
import Loader from '@/components/widgets/loader'

export default {
  extends: ModelShow,
  page: {
    title: `Detail Odoo Sale Invoice`,
  },
  components: {
    Loader,
  },
  props: {
    cardTitle: {
      default() {
        return this.lodash.startCase(this.$t("odoo_sale_invoices.singular"));
      },
    },
    resourceRoute: {default: "odoo_sale_invoices"},
    modelVariable: {default: "odoo_sale_invoice"},
    denyEdit: {type: Boolean, default: true},
    denyDelete: {type: Boolean, default: true},
    columns: {
      type: Object,
      default() {
        return {
          [this.modelVariable || "model"]: [
            {
              key: "key",
              label: this.$t("models.key"),
              component: Row,
            },
          ],
        };
      },
    },
  },
  data() {
    return {
      title: this.lodash.startCase(this.$t("odoo_sale_invoices.plural")),
      lineFields: ['label', 'quantity', 'UoM', 'price_unit', 'price_subtotal'],
      JalaAppIcon,
      JalaHarvestIcon,
      JalaProIcon,
    };
  },
  mounted() {
    this.fetchModel();
  },
  computed: {
    uniqueOrders() {
      let orders = this.model.odoo_account_move_lines
          .filter(({display_type}) => display_type === 'product')
          .map(({odoo_account_move_lineable}) => odoo_account_move_lineable?.odoo_sale_order?.sale_order)
      return this.lodash.uniqBy(orders, 'id').filter(order => order)
    },
    uniqueTickets() {
      let tickets = this.uniqueOrders.map(({ticket}) => ticket)
      return this.lodash.uniqBy(tickets, 'id')
    },
    linesToShow() {
      return this.model.odoo_account_move_lines.filter(({display_type}) => ['product', 'line_section'].includes(display_type)).sort((a, b) => a.sequence - b.sequence)
    },
    imageUrls() {
      return this.files.map(({url}) => url)
    }
  },
  methods: {
    openImageInNewTab(imageUrl) {
      window.open(imageUrl, '_blank');
    },
    customerLabelFromBankAccount(bankAccount) {
      const {customer} = bankAccount || {}
      if (!customer) {
        return '-'
      }
      return customer?.name
    },
    bankAccountLabel(bankAccount) {
      if (!bankAccount) return '-'
      const {
        bank,
        customer,
        account_number,
        name,
      } = bankAccount || {}

      if (name) {
        return `${name} - ${account_number} - ${bank?.name}`
      }
      return `${customer?.name} - ${account_number} - ${bank?.name}`
    },
    getModelName() {
      return this.model["order_id"];
    },
    fetchModel() {
      this.loading = true;
      return this.$axios
          .get(`/v1/odoo_account_moves/${this.$route.params.key}`, {
            params: {
              include: [
                "odoo_account_move_lines.odoo_account_move_lineable.odoo_sale_order.sale_order.ticket",
                "odoo_ir_attachments",
                "outstanding_account.customer",
                "outstanding_account.bank",
                "destination_account.customer",
                "destination_account.bank"
              ].join(","),
            },
          })
          .then((response) => {
            const {data: {data}} = response;
            this.$set(this, 'model', data)
            return response;
          })
          .catch((error) => this.failedAlert(error))
          .finally(() => (this.loading = false));
    },
  },
};
</script>

<style lang="scss" scoped>
::v-deep {
  .preloader-component {
    background-color: #ffffff;
  }
}
.text-right {
  text-align: right;
}
.container-title {
  margin-top: 10px;
  font-family: Lato;
  font-size: 12px;
  font-weight: 800;
  line-height: 14px;
  letter-spacing: 0.05em;
  text-align: left;
  margin-bottom: 8px;
  text-transform: uppercase;
  font-family: 'Lato';
  color: #6C7589;
}

.custom-group {
  margin-bottom: 30px;
}

.custom-label,
.custom-text {
  font-family: Lato;
  font-size: 14px;

  line-height: 17px;
  letter-spacing: 0em;
  text-align: left;
}

.custom-label,
.label {
  font-weight: 700;
  color: #161b4d;
  text-transform: capitalize;
  margin-bottom: 10px;
}

.custom-text,
.value {
  font-weight: 400;
  color: #6c7589;
}

.value:not(.no-colon)::before {
  content: ": ";
}

.section-title {
  background-color: #f9fafb;
  color: #161b4d;
  padding: 14px 21px;
  text-transform: uppercase;
  font-family: Lato;
  font-size: 14px;
  font-weight: 700;
  line-height: 17px;
  letter-spacing: 0.05em;
  text-align: left;
  border: 1px solid #ececf2;
}

.section-title:first-of-type {
  border-top: none;
}

.section-body {
  padding: 14px 20px;

  .section-label,
  .section-value {
    font-family: Lato;
    font-size: 14px;
    line-height: 17px;
    letter-spacing: 0em;
    text-align: left;
  }

  .section-label {
    color: #161b4d;
    font-weight: 400;
  }

  .section-value {
    color: #161b4d;
    font-weight: 700;
    text-align: right;
  }

  .section-row {
    padding: 6px 0;
  }
}

.sale-item-thead {
  color: #161b4d;
  background-color: #f9fafb;
  text-transform: uppercase;
  font-family: Lato;
  font-size: 14px;
  font-weight: 700;
  line-height: 17px;
  letter-spacing: 0.05em;
  text-align: left;
}

.sale-item-tbody {
  color: #161b4d;
  font-family: Lato;
  font-size: 14px;
  font-weight: 400;
  line-height: 17px;
  letter-spacing: 0em;
  text-align: left;
}

::v-deep .page-content {
  background: #eef3f7;
}

$badge-background-primary: rgba(198, 239, 255, 0.3);
$badge-color-primary: #0084f3;
$badge-background-warning: #fff8e7;
$badge-color-warning: #ff9d0b;

.badge-container {
  &-base {
    background: $badge-background-primary;

    .stakeholder {
      color: #161b4d;
      font-weight: 700;
      font-size: 14px;
    }

    .name {
      font-weight: 700;
      font-size: 20px;
    }
  }

  &-primary {
    @extend .badge-container-base;

    .name {
      color: $badge-color-primary;
    }
  }

  &-warning {
    @extend .badge-container-base;
    background: $badge-background-warning;

    .name {
      color: $badge-color-warning;
    }
  }
}

::v-deep {
  .overflow-hidden {
    overflow: hidden !important;
  }

  table {
    thead {
      background: #F9FAFB !important;
    }
  }
}
</style>